import { createFileRoute } from "@tanstack/react-router"

import { Perm } from "@/lib/permissions"
import { requirePermission } from "@/lib/route-guards"
import { SettingsUserEditPage } from "@/pages/settings/user-edit"

export const Route = createFileRoute("/_authenticated/settings/users/$id")({
  beforeLoad: async ({ context }) => {
    await requirePermission(context, Perm.MEMBERSHIP_UPDATE, { to: "/settings/users" })
  },
  component: SettingsUserEditPage,
})
